<template>
  <div class="relative">
    <div
      v-if="loading"
      class="flex items-center justify-center py-8"
      data-testid="bulk-error-spinner"
      role="status"
      aria-busy="true"
    >
      <EcxSpinner size="md" />
    </div>

    <template v-else>
      <div class="flex flex-col gap-2 overflow-y-auto max-h-96 px-4 pb-4 pt-2">
        <template v-for="error in errors" :key="`${error.line}-${error.status}`">
          <BulkImportErrorRow
            v-for="(msg, msgIndex) in error.messages"
            :key="`${error.line}-${msgIndex}`"
            :line="error.line"
            :status="error.status"
            :message="msg"
            :field="error.fields?.[msgIndex]"
            :value="error.values?.[msgIndex]"
          />
        </template>
      </div>

      <div
        v-if="pagination && pagination.pages > 1"
        class="px-4 py-3 border-t border-grey-200"
        data-testid="bulk-error-pagination"
      >
        <EcxPagination
          :current-page="pagination.page"
          :total-items="pagination.count"
          :per-page="pagination.items"
          :show-info="false"
          @page-change="(page) => emit('page-change', page)"
        />
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { EcxSpinner, EcxPagination } from '@ecx/ui'
import BulkImportErrorRow from './BulkImportErrorRow.vue'
import type { BulkImportErrorRow as BulkImportErrorRowType } from '@/types/bulkImport'
import type { PagyMeta } from '@/api/responseExtractors'

defineProps<{
  errors: BulkImportErrorRowType[]
  pagination: PagyMeta | null
  loading?: boolean
}>()

const emit = defineEmits<{
  (e: 'page-change', page: number): void
}>()
</script>
